function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var ca = document.cookie.split('; ');

    for (let i=0; i < ca.length; i++) {
        var el = ca[i];
        var cookie = el.split('=')[0];

        if (cookie === name) {
            var cookieAccepted = el.split('=')[1];
            if (cookieAccepted === 'true') return cookieAccepted
        }
    }
    return null;
}

document.getElementById('acceptCookies').addEventListener('click', function(){
    setCookie('gdpr', true, 360);
    document.getElementById('acceptCookies').parentElement.parentElement.classList.add('hidden');
});

var gdprCookie = getCookie('gdpr');
if (gdprCookie === 'true') {
    console.log(gdprCookie)
    document.getElementById('acceptCookies').parentElement.parentElement.classList.add('hidden');
}